import { ONE_AT_A_TIME_PERMISSIONS_CHECK } from "../pages/main/routerPermissionsConst";

const OneAtATime = {};
let keepAlive = null;
let vueInstance = null;
let uiReadonlyNotify = null;
let uiCanEditNotify = null;
let canEditMessage = false;
let deleted = false;

OneAtATime.install = function (Vue) {
    const storeVM = new Vue({
        data() {
            return {
                $currentRoomEmpty: true,
                $currentEditingUser: null,
                $startEdit: false
            };
        }
    });

    // Add an instance method
    Vue.prototype.$oneAtATime = {
        /**
         *
         * @param {String} ui - name of current UI, for ex. documents for Generate documents UI
         * @param {String} roomName - a unique name that identifies your UI or view, for ex. the UUID of the selected document
         */
        createRoom(ui, roomName, action) {
            deleted = false;
            const self = this;
            const { host } = window.location;
            const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";
            self.destroyCurrentRoom();
            self.currentRoom = new WebSocket(`${protocol + host}/websocket/onlyOne/${ui}-${roomName}`);

            self.currentRoom.onmessage = (msg) => {
                if (action) {
                    [, storeVM.$data.$currentEditingUser] = msg.data.split(":");
                    vueInstance.$emit(`oneAtATime-${ui}-${action}`, msg.data);
                } else if (msg.data === "false") {
                    storeVM.$data.$currentRoomEmpty = false;
                    vueInstance.$emit(`oneAtATime-${ui}`, false);
                } else if (msg.data.indexOf("username") > -1) {
                    [, storeVM.$data.$currentEditingUser] = msg.data.split(":");

                    if (uiCanEditNotify) {
                        uiCanEditNotify(); // dismiss
                    }

                    uiReadonlyNotify = Vue.prototype.$toast.showNotify({
                        type: "info",
                        message: vueInstance.$t("oneAtATime.uiReadonlyMessage", { user: storeVM.$data.$currentEditingUser }),
                        timeout: 0,
                        hasClose: false,
                        caption: vueInstance.$t("oneAtATime.uiReadonlyDetail")
                    });
                } else if (!storeVM.$data.$currentRoomEmpty && msg.data === "true") {
                    storeVM.$data.$currentRoomEmpty = true;
                    storeVM.$data.$currentEditingUser = null;
                    vueInstance.$emit(`oneAtATime-${ui}`, true);
                } else if (msg.data === "canEdit") {
                    storeVM.$data.$startEdit = true;
                    if (uiReadonlyNotify) {
                        uiReadonlyNotify(); // dismiss
                    }
                    // notify user he can edit
                    if (!canEditMessage && !deleted && !action) {
                        uiCanEditNotify = Vue.prototype.$toast.showNotify({
                            type: "info",
                            message: vueInstance.$t("oneAtATime.uiEditableMessage"),
                            timeout: 0,
                            hasClose: false,
                            buttonLabel: vueInstance.$t("oneAtATime.beginEditingAction"),
                            actionEvent: self.currentRoom.actionBeginEditing
                        });
                        canEditMessage = true;
                    }
                }
            };

            self.currentRoom.onopen = () => {
                self.currentRoom.send("edit");
                keepAlive = window.setInterval(() => {
                    self.currentRoom.send("ping");
                }, 30000);
            };
            self.currentRoom.actionBeginEditing = () => {
                self.currentRoom.send("edit");
                canEditMessage = false;
                vueInstance.$emit("startEditing");
                vueInstance.$root.$emit("hideUpdateNotify");
            };
        },

        destroyCurrentRoom() {
            if (this.currentRoom) {
                window.clearInterval(keepAlive);
                this.currentRoom.close();
            }

            vueInstance.$root.$on("deletedInterface", (data) => {
                deleted = data;
            });

            if (uiCanEditNotify) {
                uiCanEditNotify(); // dismiss
            }

            if (uiReadonlyNotify) {
                uiReadonlyNotify(); // dismiss
            }

            canEditMessage = false;
            storeVM.$data.$startEdit = false;
        },
        init(mainVueInstance) {
            vueInstance = mainVueInstance;
            // add automatic oneAtAtime
            (vueInstance.$router || []).afterEach((to, from) => {
                const routes = ["process", "dataModel", "mainApis", "smartContractDesigner", "highlights",
                    "appSpecificGroups", "permissions"];
                const specialCases = ["userInterfaces", "documents", "dataStoreLegacy", "catalogs"];
                const nameParams = ["catalogId", "documentId", "tableId"];

                // destroy room
                const destroyWebsocket = Object.entries(to.params).some(([key, value]) => nameParams.includes(key) && !value);
                if ((routes.includes(from.name) || specialCases.includes(to.name) || specialCases.includes(from.name))
                    && (from.name !== to.name || destroyWebsocket)) {
                    vueInstance.$oneAtATime.destroyCurrentRoom(from.name);
                }

                // create new room
                let appId = null;
                if (to.name === "smartContractDesigner") {
                    appId = vueInstance.$store.getters["smartContractDesigner/functionSelected"].id;
                } else if (to.name === "process") {
                    const currProcess = localStorage.getItem("processNewTab");
                    appId = currProcess ? JSON.parse(currProcess).id : vueInstance.$store.getters["apps/currentProcess"].id;
                } else {
                    appId = vueInstance.$store.getters["apps/currentApp"].id || vueInstance.$store.getters["main/getCurrentApplicationId"];
                }

                // eslint-disable-next-line no-shadow
                function checkPermissions(to) {
                    const permission = vueInstance.$route && vueInstance.$route.params && vueInstance.$route.params.permissions;
                    let isReadonly = permission && permission.readonly;

                    if (permission && permission.permissionsData && Object.keys(permission.permissionsData).length && !isReadonly) {
                        const interfaceData = ONE_AT_A_TIME_PERMISSIONS_CHECK.find(element => element.name === to.name);
                        if (interfaceData) {
                            if (Array.isArray(interfaceData.code)) {
                                let hasPermission;
                                interfaceData.code.forEach(elemCode => {
                                    if (!hasPermission) {
                                        hasPermission = permission.permissionsData[elemCode] && permission.permissionsData[elemCode] === "w";
                                        isReadonly = !hasPermission;
                                    }
                                });
                            } else {
                                isReadonly = permission.permissionsData[interfaceData.code] && permission.permissionsData[interfaceData.code] === "r";
                            }
                        }
                    }
                    return isReadonly;
                }

                if (appId && routes.indexOf(to.name) !== -1 && !checkPermissions(to)) {
                    vueInstance.$oneAtATime.createRoom(to.name, appId);
                }
            });
            vueInstance.$root.$on("checkUserOnApp", (data) => {
                vueInstance.$oneAtATime.createRoom(data.name, data.appId);
            });
        },
        currentRoom: null,
        get state() {
            return storeVM.$data;
        }
    };
};

export default OneAtATime;
